// Централизирани кодове и помощни методи за типове организационни документи
export const OrganizationalDocUploadTypeCode = Object.freeze({
    BusinessTripOrder: 'BusinessTripOrder',
    Order: 'Order',
    Contract: 'Contract',
    Request: 'Request',
    Miscellaneous: 'Miscellaneous',
});

export const getDocumentUploadTypeOptions = (i18n) => {
    if (!i18n || !i18n.t) {
        return [];
    }

    const t = (key) => i18n.t(key);

    return [
        {
            value: OrganizationalDocUploadTypeCode.BusinessTripOrder,
            text: t('documentsSettings.types.businessTripOrder')
        },
        {
            value: OrganizationalDocUploadTypeCode.Order,
            text: t('documentsSettings.types.order')
        },
        {
            value: OrganizationalDocUploadTypeCode.Contract,
            text: t('documentsSettings.types.contract')
        },
        {
            value: OrganizationalDocUploadTypeCode.Request,
            text: t('documentsSettings.types.request')
        },
        {
            value: OrganizationalDocUploadTypeCode.Miscellaneous,
            text: t('documentsSettings.types.miscellaneous')
        },
    ];
};

export const getDocumentUploadTypeText = (code, i18n) => {
    if (!code || !i18n || !i18n.t) {
        return '';
    }

    const t = (key) => i18n.t(key);

    switch (code) {
        case OrganizationalDocUploadTypeCode.BusinessTripOrder:
            return t('documentsSettings.types.businessTripOrder');
        case OrganizationalDocUploadTypeCode.Order:
            return t('documentsSettings.types.order');
        case OrganizationalDocUploadTypeCode.Contract:
            return t('documentsSettings.types.contract');
        case OrganizationalDocUploadTypeCode.Request:
            return t('documentsSettings.types.request');
        case OrganizationalDocUploadTypeCode.Miscellaneous:
            return t('documentsSettings.types.miscellaneous');
        default:
            return code;
    }
};
